import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { repTempActionTypes } from '../actions/reportTemplateActionTypes';
import { updateTableConfig } from './utilities/utility';

export const REDUCER_NAME = 'ReportCenter';

const logListRequest = (state, action) => ({
  ...state,
  listRequest: action.data || state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const resetServerError = (state, action) => ({
  ...state,
  serverRequestError: action.data?.serverRequestError,
  loading: false,
});

const handleReportListActions = (state, action) => {
  switch (action.type) {
    case repTempActionTypes.SET_REPORT_CENTER_LIST_REQUEST:
      return {
        ...state,
        reportTemplateList: action.data,
      };
    case repTempActionTypes.SET_REPORT_CENTER_LIST_REQUEST_BY_ID:
      return {
        ...state,
        reportTemplateById: action.data,
      };
    case repTempActionTypes.RESET_REPORT_CENTER_LIST_REQUEST_BY_ID:
      return {
        ...state,
        reportTemplateById: undefined,
      };
    default:
      return null;
  }
};

const handleReportTemplateActions = (state, action) => {
  switch (action.type) {
    case repTempActionTypes.LOG_REPORT_TEMP_LIST_REQUEST:
      return logListRequest(state, action);
    case repTempActionTypes.GET_REPORT_TEMP_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case repTempActionTypes.GET_REPORT_TEMP_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case repTempActionTypes.RESET_REPORT_TEMP_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case repTempActionTypes.UPDATE_REPORT_TEMP_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case repTempActionTypes.SS_RESET_SERVER_VALUE:
      return resetServerError(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
};

const handleShareReportTemplateActions = (state, action) => {
  switch (action.type) {
    case repTempActionTypes.SAVE_SHARE_REPORT_TEMPLATE_RESPONSE:
      return {
        ...state,
        saveShareInfoResponse: action.data,
      };
    case repTempActionTypes.GET_SHARE_REPORT_TEMPLATE_RESPONSE:
      return {
        ...state,
        shareReportTemplateData: action.data,
      };
    case repTempActionTypes.SHARE_REPORT_TEMPLATE_ERROR:
      return { ...state,
        saveShareInfoError: action.data,
      };
    case repTempActionTypes.RESET_SHARE_REPORT_TEMPLATE_STORE:
      return { ...state,
        saveShareInfoError: null,
        saveShareInfoResponse: null,
        shareReportTemplateData: null,
      };
    default:
      return null;
  }
};

const handleDeleteReportTemplateActions = (state, action) => {
  switch (action.type) {
    case repTempActionTypes.DELETE_REPORT_TEMPLATE_RESET:
      return {
        ...state,
        deleteReportTemplate: null,
        deleteReportTemplateError: null,
      };
    case repTempActionTypes.DELETE_REPORT_TEMPLATE_RESPONSE:
      return {
        ...state,
        deleteReportTemplate: action.data,
      };
    case repTempActionTypes.DELETE_REPORT_TEMPLATE_ERROR:
      return {
        ...state,
        deleteReportTemplateError: action.data,
      };
    default:
      return null;
  }
};

const reportScheduleTemplateActions = (state, action) => {
  switch (action.type) {
    case repTempActionTypes.GET_REPORT_SCHEDULE_RESET:
      return {
        ...state,
        scheduleInfoError: null,
        scheduleInfo: null,
        savedScheduleInfo: null,
        saveScheduleInfoError: null, // CTFSLCAC-4361: Clear save error on reset to prevent stale error display
      };
    case repTempActionTypes.GET_REPORT_SCHEDULE_RESPONSE:
      return {
        ...state,
        scheduleInfo: action.data,
      };
    case repTempActionTypes.GET_REPORT_SCHEDULE_ERROR:
      return {
        ...state,
        scheduleInfoError: action.data,
      };

    case repTempActionTypes.SAVE_REPORT_SCHEDULE_RESET:
      return {
        ...state,
        saveScheduleInfoError: null,
        savedScheduleInfo: null,
      };
    case repTempActionTypes.SAVE_REPORT_SCHEDULE_RESPONSE:
      return {
        ...state,
        savedScheduleInfo: action.data,
      };
    case repTempActionTypes.SAVE_REPORT_SCHEDULE_ERROR:
      return {
        ...state,
        saveScheduleInfoError: action.data,
      };
    default:
      return null;
  }
};

const ReportCenterReducer = (state = { ...basicFilterInitialState }, action = null) => {
  const configState = handleReportListActions(state, action);
  if (configState !== null) {
    return configState;
  }
  const requestState = handleReportTemplateActions(state, action);
  if (requestState !== null) {
    return requestState;
  }
  const shareReportTemplateState = handleShareReportTemplateActions(state, action);
  if (shareReportTemplateState !== null) {
    return shareReportTemplateState;
  }
  const deleteReportTemplateState = handleDeleteReportTemplateActions(state, action);
  if (deleteReportTemplateState !== null) {
    return deleteReportTemplateState;
  }
  const reportScheduleState = reportScheduleTemplateActions(state, action);
  if (reportScheduleState !== null) {
    return reportScheduleState;
  }
  return state;
};

export default ReportCenterReducer;
